import React, { useEffect, useState } from 'react';
import Headerdash from "./head";
import Sidebar from "./sidebar";
import PieCharts from "../bars/pie";
import { FcLeave } from "react-icons/fc";
import Loading from './MockTest/SpinnerLoading';



export default function Dashboard() {

  const [dashboardData, setDashboardData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // New state for loading



  useEffect(() => {
      const fetchDashboardData = async () => {
          try {
              const response = await fetch('/api/dashboard', {
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json',
                      // Add any necessary authorization headers if required
                  },
                  // You can include credentials: 'include' if cookies/sessions are used for authentication
              });
              if (!response.ok) {
                  throw new Error('Failed to fetch dashboard data');
              }
              const data = await response.json();
              setDashboardData(data);
          } catch (error) {
              console.error('Error fetching dashboard data:', error);
          }
      };

      fetchDashboardData();
  }, []);
  useEffect(() => {
      const checkSubscription = async () => {
          try {
              const response = await fetch('/api/check-subscription-cron', {
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json',
                      // Add any necessary authorization headers if required
                  },
                  // You can include credentials: 'include' if cookies/sessions are used for authentication
              });
              if (!response.ok) {
                  throw new Error('Failed to fetch dashboard data');
              }
              const data = await response.json();
          } catch (error) {
              console.error('Error fetching dashboard data:', error);
          }
      };

      checkSubscription();
  }, []);
  if (error) {
    return <div>Error: {error}</div>;
}

if (!dashboardData) {
    return <div>  {isLoading && <Loading />}
    </div>;
}

  const totalQuestionsSpeakingZone = dashboardData['Speaking Zone']?.totalQuestions || 0;
  const totalQuestionsWritingZone = dashboardData['Writing Zone']?.totalQuestions || 0;
  const totalQuestionsReadingZone = dashboardData['Reading Zone']?.totalQuestions || 0;
  const totalQuestionsListeningZone = dashboardData['Listening Zone']?.totalQuestions || 0;

  const totalAttemptedQuestionsSpeakingZone = dashboardData['Speaking Zone']?.attemptedQuestions || 0;
  const totalAttemptedQuestionsWritingZone = dashboardData['Writing Zone']?.attemptedQuestions || 0;
  const totalAttemptedQuestionsReadingZone = dashboardData['Reading Zone']?.attemptedQuestions || 0;
  const totalAttemptedQuestionsListeningZone = dashboardData['Listening Zone']?.attemptedQuestions || 0;


  const totalQuestionPracticed = totalAttemptedQuestionsSpeakingZone + totalAttemptedQuestionsWritingZone + totalAttemptedQuestionsReadingZone + totalAttemptedQuestionsListeningZone

  return (
    <div className="relative h-screen">
      <Headerdash />
      <Sidebar />

      <section>
        <div className=" relative md:left-36 md:top-24 max-w-6xl md:px-10 md:px-96 pt-24 mx-auto mb-10">
        <div className="md:relative md:right-96 md:bottom-24">
  <h3 className="font-bold text-center text-lg p-5 text-gray-700 bg-slate-50">
    Estimated Score in Exams
  </h3>
  <div className="flex flex-col md:flex-row bg-slate-100">
    <div className="flex-1 flex gap-2 pl-12 md:pr-20 md:px-16 mb-10 md:mr-6 rounded-sm mx-auto h-[350px]">
      <div className="relative md:bottom-6 w-90">
        <h3 className="absolute top-[184px] left-[100px] text-center font-extrabold text-gray-700 text-4xl">
          82
        </h3>
        <PieCharts />
      </div>
    </div>

    {/* Box */}
    <div className="md:absolute md:left-[400px] top-0 flex flex-col gap-4 mb-9">
      {/* Row 1 */}
      <div className="flex-1 bg-slate-100 py-6 rounded-sm max-w-3xl md:w-[750px]">
        <div className="flex flex-col md:flex-row">
          <div className="flex-1 md:w-1/4 px-32 py-4 md:px-10 md:py-10 mx-5 mt-3 md:mt-0 bg-white rounded-sm">
            <h3 className="text-center font-bold text-sm mb-9 underline text-gray-700">
              Mock Practiced
            </h3>
            <h4 className="font-extrabold text-gray-700 text-center">0</h4>
          </div>
          <div className="flex-1 md:w-1/4 px-32 py-4 md:px-10 md:py-10 mx-5 mt-3 md:mt-0 bg-white rounded-sm">
            <h3 className="text-center font-bold text-sm mb-10 underline text-gray-700">
              Desired Score
            </h3>
            <h4 className="font-extrabold text-gray-700 text-center">N/A</h4>
          </div>
          <div className="flex-1 md:w-1/4 px-32 py-4 md:px-10 md:py-10 mx-5 mt-3 md:mt-0 bg-white rounded-sm">
            <h3 className="text-center font-bold text-sm mb-10 underline text-gray-700">
              Exam Date
            </h3>
            <h4 className="font-extrabold text-gray-700 text-center">N/A</h4>
          </div>
          <div className="flex-1 md:w-1/4 px-32 py-4 md:px-10 md:py-10 mx-5 mt-3 md:mt-0 bg-white rounded-sm">
            <h3 className="text-center font-bold text-sm mb-10 underline text-gray-700">
              Days Left
            </h3>
            <h4 className="font-extrabold text-gray-700 text-center">N/A</h4>
          </div>
        </div>
      </div>

      {/* Row 2 */}
      <div className="flex-1 bg-slate-100 py-6 rounded-sm">
        <div className="flex flex-col md:flex-row">
          <div className="flex-1 md:w-1/4 px-32 py-4 md:px-10 md:py-10 mx-5 mt-3 md:mt-0 bg-white rounded-sm">
            <h3 className="text-center font-bold text-sm mb-2 underline text-gray-700">
              Question Practiced
            </h3>
            <h4 className="font-extrabold text-gray-700 text-center">{totalQuestionPracticed}</h4>
          </div>
          <div className="flex-1 md:w-1/4 px-32 py-4 md:px-10 md:py-10 mx-5 mt-3 md:mt-0 bg-white rounded-sm">
            <h3 className="text-center font-bold text-sm mb-3 underline text-gray-700">
              Daily Practice
            </h3>
            <h4 className="font-extrabold text-gray-700 text-center">N/A</h4>
          </div>
          <div className="flex-1 md:w-1/4 px-32 py-4 md:px-10 md:py-10 mx-5 mt-3 md:mt-0 bg-white rounded-sm">
            <h3 className="text-center font-bold text-sm mb-10 underline text-gray-700">
              Weekly Prediction
            </h3>
            <h4 className="font-extrabold text-gray-700 text-center">N/A</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


        </div>

        {/* Practice Result Section */}
        <div className="mx-w-6xl grid md:grid-cols-2 gap-4-100 mt-1 px-7 md:px-0 md:pl-[290px] ">
          <div className="bg-green-300 m-3 rounded-sm">
            <div className=" flex flex-row py-6 px-2 rounded-sm">
              <div className="flex-1 px-3 text-white font-bold">Speaking</div>
              <div className="flex-1 px-3 text-white font-bold">{totalAttemptedQuestionsSpeakingZone}</div>
              <div className="flex-1 px-3 text-white font-bold">{totalQuestionsSpeakingZone}</div>
              <div className="flex-1 px-3 text-white font-bold">
                Average Score
              </div>
              
            </div>
            <div className=" flex flex-row pb-4 px-2 rounded-sm text-sm">
              <div className="flex-1 px-3 text-white font-bold underline">Questions</div>
              <div className="flex-1 px-3 text-white font-bold underline">Done</div>
              <div className="flex-1 px-3 text-white font-bold underline">Total</div>
              <div className="flex-1 px-3 text-white font-bold underline">
                30
              </div>
              
            </div>
          </div>
          <div className="bg-blue-300 m-3 rounded-sm">
            <div className=" flex flex-row py-6 px-2 rounded-sm">
              <div className="flex-1 px-3 text-white font-bold">Writing</div>
              <div className="flex-1 px-3 text-white font-bold">{totalAttemptedQuestionsWritingZone}</div>
              <div className="flex-1 px-3 text-white font-bold">{totalQuestionsWritingZone}</div>
              <div className="flex-1 px-3 text-white font-bold">
                Average Score
              </div>
            </div>
            <div className=" flex flex-row pb-4 px-2 rounded-sm text-sm">
              <div className="flex-1 px-3 text-white font-bold underline">Questions</div>
              <div className="flex-1 px-3 text-white font-bold underline">Done</div>
              <div className="flex-1 px-3 text-white font-bold underline">Total</div>
              <div className="flex-1 px-3 text-white font-bold underline">
                30
              </div>
              
            </div>
          </div>
          
          <div className="bg-orange-300 m-3 rounded-sm">
            {" "}
            <div className=" flex flex-row py-6 px-2 rounded-sm">
              <div className="flex-1 px-3 text-white font-bold">Reading</div>
              <div className="flex-1 px-3 text-white font-bold">{totalAttemptedQuestionsReadingZone}</div>
              <div className="flex-1 px-3 text-white font-bold">{totalQuestionsReadingZone}</div>
              <div className="flex-1 px-3 text-white font-bold">
                Average Score
              </div>
            </div>
            <div className=" flex flex-row pb-4 px-2 rounded-sm text-sm">
              <div className="flex-1 px-3 text-white font-bold underline">Questions</div>
              <div className="flex-1 px-3 text-white font-bold underline">Done</div>
              <div className="flex-1 px-3 text-white font-bold underline">Total</div>
              <div className="flex-1 px-3 text-white font-bold underline">
                30
              </div>
              
            </div>
          </div>
          <div className="bg-purple-400 m-3 rounded-sm">
            {" "}
            <div className=" flex flex-row py-6 px-2 rounded-sm">
              <div className="flex-1 px-3 text-white font-bold">Listening</div>
              <div className="flex-1 px-3 text-white font-bold">{totalAttemptedQuestionsListeningZone}</div>
              <div className="flex-1 px-3 text-white font-bold">{totalQuestionsListeningZone}</div>
              <div className="flex-1 px-3 text-white font-bold">
                Average Score
              </div>
            </div>
            <div className=" flex flex-row pb-4 px-2 rounded-sm text-sm">
              <div className="flex-1 px-3 text-white font-bold underline">Questions</div>
              <div className="flex-1 px-3 text-white font-bold underline">Done</div>
              <div className="flex-1 px-3 text-white font-bold underline">Total</div>
              <div className="flex-1 px-3 text-white font-bold underline">
                30
              </div>
              
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
